class Workshop3Activite2CsvGenerator {
  constructor(data, lang = "fr") {
    this.data = data || {};
    this.scenarios = this.data.scenarios || [];
    this.organizationName = this.data.organizationName || "Organization";
    this.lang = lang;
    this.labels = lang === "en" ? this.getEnLabels() : this.getFrLabels();
  }

  getFrLabels() {
    return {
      title: "ATELIER 3 - ACTIVITÉ 2 : SCÉNARIOS STRATÉGIQUES",
      scenarios: "SCÉNARIOS STRATÉGIQUES",
      scenarioNumber: "N° Scénario",
      sourceRisk: "Source de risque",
      sourceCategory: "Catégorie",
      target: "Objectif Visé",
      dreadedEvent: "Événement Redouté",
      severity: "Gravité",
      niveau: "Niveau",
      niveau1: "Niveau 1 (Faible)",
      niveau2: "Niveau 2 (Modéré)",
      niveau3: "Niveau 3 (Élevé)",
      niveau4: "Niveau 4 (Très élevé)",
      businessValue: "Valeur Métier",
      description: "Description",
      retained: "Retenu",
      yes: "Oui",
      no: "Non",
      catastrophic: "Catastrophique",
      critical: "Critique",
      major: "Majeure",
      moderate: "Modérée",
      minor: "Mineure",
      undefined: "Non défini",
      noScenarios: "Aucun scénario stratégique défini",
    };
  }

  getEnLabels() {
    return {
      title: "WORKSHOP 3 - ACTIVITY 2: STRATEGIC SCENARIOS",
      scenarios: "STRATEGIC SCENARIOS",
      scenarioNumber: "Scenario #",
      sourceRisk: "Risk Source",
      sourceCategory: "Category",
      target: "Target Objective",
      dreadedEvent: "Feared Event",
      severity: "Severity",
      niveau: "Level",
      niveau1: "Level 1 (Low)",
      niveau2: "Level 2 (Moderate)",
      niveau3: "Level 3 (High)",
      niveau4: "Level 4 (Very High)",
      businessValue: "Business Value",
      description: "Description",
      retained: "Retained",
      yes: "Yes",
      no: "No",
      catastrophic: "Catastrophic",
      critical: "Critical",
      major: "Major",
      moderate: "Moderate",
      minor: "Minor",
      undefined: "Undefined",
      noScenarios: "No strategic scenarios defined",
    };
  }

  createSectionHeader(title) {
    return `<tr><td colspan="10" style="background-color: #1E40AF; color: white; font-weight: bold; font-size: 14px; padding: 10px 8px;">${title}</td></tr>`;
  }

  createTableHeader(headers) {
    return `<tr>
            ${headers.map((h) => `<td style="background-color: #3B82F6; color: white; font-weight: bold; padding: 8px; border: 1px solid #93C5FD;">${h}</td>`).join("")}
        </tr>`;
  }

  createDataRow(cells) {
    return `<tr>
            ${cells.map((c) => `<td style="padding: 6px 8px; border: 1px solid #E2E8F0; vertical-align: top;">${c || ""}</td>`).join("")}
        </tr>`;
  }

  getNiveauText(niveau) {
    const level = parseInt(niveau) || 0;
    switch (level) {
      case 1:
        return this.labels.niveau1;
      case 2:
        return this.labels.niveau2;
      case 3:
        return this.labels.niveau3;
      case 4:
        return this.labels.niveau4;
      default:
        return niveau || "";
    }
  }

  getNiveauColor(niveau) {
    const level = parseInt(niveau) || 0;
    switch (level) {
      case 1:
        return "background-color: #DCFCE7; color: #166534;";
      case 2:
        return "background-color: #FEF9C3; color: #854D0E;";
      case 3:
        return "background-color: #FED7AA; color: #9A3412;";
      case 4:
        return "background-color: #FEE2E2; color: #991B1B;";
      default:
        return "background-color: #F1F5F9; color: #475569;";
    }
  }

  getSeverityText(severity) {
    const sevMap = {
      catastrophic: this.labels.catastrophic,
      critical: this.labels.critical,
      major: this.labels.major,
      moderate: this.labels.moderate,
      minor: this.labels.minor,
    };
    return sevMap[severity] || this.labels.undefined;
  }

  generateScenariosSection() {
    if (!this.scenarios || this.scenarios.length === 0) {
      return (
        this.createSectionHeader(this.labels.scenarios) +
        `<tr><td colspan="10" style="padding: 8px; color: #6B7280; font-style: italic;">${this.labels.noScenarios}</td></tr>`
      );
    }

    const headers = [
      this.labels.scenarioNumber,
      this.labels.sourceRisk,
      this.labels.sourceCategory,
      this.labels.dreadedEvent,
      this.labels.severity,
      this.labels.niveau,
      this.labels.businessValue,
    ];

    const rows = this.scenarios
      .map((s) => {
        const niveauColor = this.getNiveauColor(s.niveau);
        return this.createDataRow([
          s.scenarioNumber || "",
          s.sourceRisk || "",
          s.sourceCategory || "",
          s.dreadedEvent || "",
          this.getSeverityText(s.severity),
          `<span style="${niveauColor} padding: 2px 6px; border-radius: 4px;">${this.getNiveauText(s.niveau)}</span>`,
          s.businessValue || "",
        ]);
      })
      .join("");

    return (
      this.createSectionHeader(this.labels.scenarios) +
      this.createTableHeader(headers) +
      rows
    );
  }

  generateHtml() {
    const sections = [this.generateScenariosSection()];

    return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
    table { border-collapse: collapse; width: 100%; font-family: Calibri, Arial, sans-serif; }
    tr:nth-child(even) td { background-color: #F8FAFC; }
    tr:hover td { background-color: #EFF6FF; }
    tr { page-break-inside: avoid; }
</style>
</head>
<body>
<table>
${sections.join("\n\n")}
</table>
</body>
</html>`;
  }

  download(filename) {
    const htmlContent = this.generateHtml();
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + htmlContent], {
      type: "application/vnd.ms-excel;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  }
}

export default Workshop3Activite2CsvGenerator;
